import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { ICartItemFormValues } from "../Schema";
import { CartItemOptionGroup } from "./CartItemOptionGroup";
import styles from "./CartItemOptionGroups.module.css";

interface CartItemOptionGroupsProps {
  isMenuItemAvailableOnline: boolean;
}
export const CartItemOptionGroups = ({ isMenuItemAvailableOnline }: CartItemOptionGroupsProps) => {
  const { submitCount, errors, isSubmitting, values } = useFormikContext<ICartItemFormValues>();

  const optionGroupsProps = values.optionGroups?.map((o, index) => ({
    name: `optionGroups.${index}`,
    ref: React.createRef<HTMLDivElement>(),
    labelId: `optionGroupLabel-${index}`, // Add unique label ID for each group
    groupName: o.name, // Assuming `name` contains the group name
  }));

  useEffect(() => {
    if (optionGroupsProps && errors.optionGroups && submitCount > 0 && isSubmitting) {
      const firstError = Object.entries(errors.optionGroups).find(([, error]) => error);
      if (firstError && firstError[0]) {
        const index = parseInt(firstError[0]);
        const ref = optionGroupsProps[index].ref && optionGroupsProps[index].ref.current;
        ref?.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }, [optionGroupsProps, errors.optionGroups, submitCount, isSubmitting]);

  return optionGroupsProps?.map((props, i) => {
    return (
      <div
        key={i}
        ref={props.ref}
        role="group"
        style={{ width: "100%" }}
        aria-labelledby={props.labelId} // Associate group with hidden label
      >
        <div id={props.labelId} className={styles.srOnly}>
          {props.groupName}
        </div>
        <CartItemOptionGroup
          data-testid={props.name}
          isAvailable={isMenuItemAvailableOnline}
          {...props}
        />
      </div>
    );
  });
};
